import { cloneElement, useState } from "react";
import styles from "./learningSocialSharingMenu.module.scss";
import { ActionSheet } from "@kunduz/ui-molecules";

export const LearningSocialSharingMenu = (props: Props) => {
  const {
    isMobile,
    copyText,
    emailText,
    facebookText,
    popupTitle,
    twitterText,
    trigger,
  } = props;
  const [showSharingMenu, setShowSharingMenu] = useState(false);
  const baseUrl = window.location.href;

  const copyBaseUrl = () => navigator.clipboard.writeText(baseUrl);

  const onClose = () => setShowSharingMenu(false);

  const renderContent = () => (
    <div className={styles["container"]}>
      <div className={styles["headerContainer"]}>
        <div className={styles["header"]}>{popupTitle}</div>
        <div className={styles["closeIcon"]} onClick={onClose}>
          X
        </div>
      </div>
      <div className={styles["content"]}>
        <a
          href={`https://www.facebook.com/sharer/sharer.php?u=${baseUrl}`}
          target="_blank"
          className={styles["sharingButton"]}
          rel="noreferrer"
        >
          <img
            loading="lazy"
            src="/images/socialFacebookIcon.png"
            alt="facebook"
          />
          {facebookText}
        </a>
        <a
          href={`https://twitter.com/share?url=${baseUrl}`}
          target="_blank"
          rel="noreferrer"
          className={styles["sharingButton"]}
        >
          <img
            loading="lazy"
            src="/images/socialTwitterIcon.png"
            alt="twitter"
          />
          {twitterText}
        </a>
        <a href={`mailto:?body=${baseUrl}`} className={styles["sharingButton"]}>
          <img loading="lazy" src="/images/socialEmailIcon.png" alt="email" />
          {emailText}
        </a>

        <div onClick={copyBaseUrl} className={styles["sharingButton"]}>
          <img
            loading="lazy"
            src="/images/socialSharingIcon.png"
            alt="copy-link"
          />
          {copyText}
        </div>
      </div>
    </div>
  );

  const mobileTrigger = cloneElement(trigger as any, {
    onClick: (e: Event) => {
      setShowSharingMenu(true);
    },
  });

  if (isMobile) {
    return (
      <ActionSheet height={300} trigger={trigger}>
        <div style={{ padding: 8 }}>{renderContent()}</div>
      </ActionSheet>
    );
  } else if (showSharingMenu) {
    return renderContent();
  } else return <>{mobileTrigger}</>;
};

interface Props {
  isMobile: boolean;
  copyText: string;
  emailText: string;
  twitterText: string;
  facebookText: string;
  popupTitle: string;
  trigger: JSX.Element;
}
